import { render, staticRenderFns } from "./vip-payment-record.vue?vue&type=template&id=5892904c"
import script from "./vip-payment-record.vue?vue&type=script&lang=ts"
export * from "./vip-payment-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports